const startsWithCompanyPredicateFactory = (inputText) => {
	const lower = inputText.toLowerCase();
	return (company) => {
		return (
			'name' in company && company.name.toLowerCase().startsWith(lower)
		);
	};
};

export default () => ({
	inputText: '',
	selectedId: null,
	showPossibleCompanies: false,
	companies: [],
	shownCompanies() {
		const companyFilter = startsWithCompanyPredicateFactory(this.inputText);
		return this.companies.filter(companyFilter);
	},
	init() {
		fetch('/api/companies', {
			method: 'GET',
			headers: {
				accept: 'application/json',
			},
		})
			.then((resp) => resp.json())
			.then((data) => {
				if ('data' in data && 'companies' in data.data) {
					this.companies = [...data.data.companies];
					return;
				}
			});
	},
});
